/* istanbul ignore file */

import {
  FetchArgs,
  BaseQueryFn,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import humps from "humps";
import { logout } from "../api/adapter";
import { Params } from "../types/Common";
import { refreshTokenIfExpired } from "@asayinc/component-library";

// camelizes all response data
export const getBaseQueryWithCamelize = (
  baseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    // eslint-disable-next-line @typescript-eslint/ban-types
    {},
    FetchBaseQueryMeta
  >
) => {
  const baseQueryWithCamelize: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
  > = async (args, api, extraOptions = {}) => {
    // decamelize request fields
    if (typeof args !== "string") {
      args.body = humps.decamelizeKeys(args.body);
    }
    const result = await baseQuery(args, api, extraOptions);
    // skip for sentiment data
    if (result.data && args !== "qa-events/sentiment/") {
      // camelize response data
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      result.data = humps.camelizeKeys(result.data as any);
    }
    return result;
  };
  return baseQueryWithCamelize;
};

export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_CONSUMER_API}v3/portal/`,
  prepareHeaders: async (headers) => {
    const token = await refreshTokenIfExpired(logout);
    headers.set("Authorization", `JWT ${token}`);
    const companyOverride = window.localStorage.getItem("company-override");
    if (companyOverride) headers.set("Company-Override", companyOverride);
    return headers;
  },
});

export const baseQueryWithCamelize = getBaseQueryWithCamelize(baseQuery);

export const stripEmptyParams = (params: Params) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v != null && v != "")
  );
